var apiEndPoint = 'https://info.thepauselife.com/shopify-metaobjects/';
var SHOP = Shopify.shop;
var getRandomInRange = function(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
var currentUrl = new URL(window.location.href);
var pathName = currentUrl.pathname;
var params = new URLSearchParams(currentUrl.search);

var updateMenuMetaobjects = function () {
  jQuery('[data-ele="metaobjects-block-skelton"]').each(function (_, element) {
    
    let metaObjectBlock = jQuery(element);
    let section_type = metaObjectBlock.attr('data-section-type');
    let data_metaobject_type = metaObjectBlock.attr('data-metaobject-type');
    let data_items = metaObjectBlock.attr('data-items');
    let data_speed_sec = parseInt(metaObjectBlock.attr('data-speed')) * 1000;

    let params_val = new URLSearchParams({
      PER_PAGE: data_items,
      SHOP: SHOP,
      TYPE: data_metaobject_type,
      ...(section_type === 'page' && {
        endCursor: (params.get("endCursor") || "").replace(" ", "+"),
        startCursor: (params.get("startCursor") || "").replace(" ", "+")
      })
    });

    fetch(`${apiEndPoint}?${params_val}`)
      .then(res => res.json())
      .then(data => {
        let edges = data?.data?.metaobjects?.edges || [];
        if (!edges.length) return;

        let total_result = edges.length;
        let currentIndex = getRandomInRange(0, 5);

        function displayNextItem() {
          // if (section_type !== 'page') metaObjectBlock.find('[data-ele="grid-meta__list"]').empty();
          initResponseData(data, metaObjectBlock, section_type !== 'page' ? currentIndex : undefined);
          currentIndex = (currentIndex + 1) % total_result;
        }

        displayNextItem();
        if (section_type !== 'page'){
          setInterval(displayNextItem, data_speed_sec);
        }
      })
      .catch(error => console.error("Error fetching meta objects:", error));
  });
};

updateMenuMetaobjects();




var initResponseData = function (response, resultContainer, itemIndex) {
  if(typeof resultContainer != "undefined" || resultContainer){
    itemsResultContainer = resultContainer;
  }
  card_HTML_template = itemsResultContainer.find('[data-ele="card-item-skelton-html"]').html();
  pagination_HTML_template = itemsResultContainer.find('[data-ele="pagination-item-skelton-html"]').html();
  itemsResultContainer.find('[data-ele="skelton"]').remove();
  itemsResultContainer.find('[data-ele="grid-meta__list"]').empty();
  if (
    response.data &&
    response.data.metaobjects &&
    response.data.metaobjects.edges &&
    response.data.metaobjects.pageInfo
  ) {
    var responseObjectItems = response.data.metaobjects.edges;
    var responsePageInfo = response.data.metaobjects.pageInfo;
    var metaobjectsHTML = "";
    var prevPageURL = "";
    var nextPageURL = "";
    var current_page_items = 0;
    if (responseObjectItems.length > 0 && typeof card_HTML_template != 'undefined') {
      current_page_items = responseObjectItems.length;
      jQuery.each(responseObjectItems, function (key, value) {
        if(value?.node?.fields && (itemIndex === undefined || key === itemIndex)) {
          var responseObjectItemsProp = value.node.fields;
          var itemUrl = "";
          var itemTitle = "";
          var itemName = "";
          var imageHtml = "";
          var sortOrder = "";
          var image_url = "";
          jQuery.each(responseObjectItemsProp, function (key, item) {
            if (item.key === "content_url" && item.value != null) {
              itemUrl = item.value;
            }

            if (item.key === "outlet_name" && item.value != null) {
              itemName = item.value;
            }

            if (item.key === "content_title" && item.value != null) {
              itemTitle = item.value;
            }

            if (item.key === "sort_order" && item.value != null) {
              sortOrder = item.value;
            }

            if (
              item.key === "image" &&
              item.value != null &&
              item.reference != null
            ) {
              //image_url = item.reference?.previewImage?.src;
              image_url = item.reference?.preview?.image?.src;
            }
          });

          var itemHTML = card_HTML_template
            .replace(/__ITEM_URL__/g, itemUrl)
            .replace(/__SORT_ORDER__/g, sortOrder)
            .replace(/__ITEM_OUTLET_NAME__/g, itemName)
            .replace(/__ITEM_CONTENT_TITLE__/g, itemTitle)
            .replace(/__ITEM_IMAGE_URL__/g, image_url);

          itemHTML = jQuery(itemHTML);
          if (image_url) {
            itemHTML.find(".card-item-placeholder-image").remove();
          } else {
            itemHTML.find(".card-item-image").remove();
          }

          itemHTML
            .find('[data-ele="skelton-box"], [data-ele="skelton"]')
            .removeAttr("data-ele");
          itemHTML.removeAttr("data-ele");

          itemsResultContainer
            .find('[data-ele="grid-meta__list"]')
            .append(itemHTML);
        }
      });
    }

    if ((responsePageInfo.hasNextPage || responsePageInfo.hasPreviousPage) && typeof pagination_HTML_template != 'undefined') {
      var baseURL = `${currentUrl.origin}${currentUrl.pathname}?name=${name}`;
      console.log(baseURL);

      if (responsePageInfo.hasNextPage) {
        nextPageURL = `${baseURL}&endCursor=${responsePageInfo.endCursor}`;
      } else {
        nextPageURL = ""; // Ensure nextPageURL is empty if no next page
      }

      if (responsePageInfo.hasPreviousPage) {
        prevPageURL = `${baseURL}&startCursor=${responsePageInfo.startCursor}`;
      } else {
        prevPageURL = ""; // Ensure prevPageURL is empty if no previous page
      }

      var paginationHTML = pagination_HTML_template
        .replace(/__PREV_PAGE__/g, prevPageURL)
        .replace(/__NEXT_PAGE__/g, nextPageURL)
        .replace(/__ITEMS_PER_PAGE__/g, current_page_items);

      var $paginationHTML = jQuery(paginationHTML);

      if (!responsePageInfo.hasNextPage) {
        $paginationHTML.find('[data-ele="next-page-link"]').remove();
      }

      if (!responsePageInfo.hasPreviousPage) {
        $paginationHTML.find('[data-ele="prev-page-link"]').remove();
      }

      itemsResultContainer
        .find('[data-ele="items-pagination"]')
        .html($paginationHTML);
    }
  }
};
